import { Organization } from "@common/types/organization";
import { OrganizationAvatar } from "@components/avatar/OrganizationAvatar";
import { Tag } from "@design-system/Tag/Tag";
import styles from "./WorkspaceMembers.module.scss";

interface Props {
    organization: Organization;
}

export const OrganizationCard: React.FC<Props> = ({ organization }) => (
    <div className={styles.card}>
        <OrganizationAvatar organization={organization} size="md" aria-hidden />
        <div className={styles.organizationName}>
            {organization.name}
            <Tag color="neutral" size="sm">
                Organization
            </Tag>
        </div>
    </div>
);
